import React from 'react';

import useAutoCollection from '../../utilities/useAutoCollection';
import ListView from '../shared/lists/ListView';
import DetailEditor from './DetailEditor';

const DetailList = ({
    disabled,
    items,
    miscSaleId,
    formChange
}) => {
    const setData = (data) => formChange({ target: { name: 'miscSaleDetails', value: data } });

    const newItem = { id: 0, miscSaleId: miscSaleId, description: '', amount: '' };

    const { itemChange, itemDelete } = useAutoCollection(items, setData, !disabled, newItem);
    
    const tableHead = (
        <thead className="d-none">
        </thead>
    );

    const getItems = () => {
        const keyedItems = items.filter(item => item.reactKey !== undefined);
        return keyedItems.map((item, index) =>
        (
            <DetailEditor
                deleteItem={() => itemDelete(index)}
                formChange={(e) => itemChange(e, index)}
                item={item}
                key={item.reactKey}
                disabled={disabled}
                />
            ));
    }

    return (
        <ListView
            className="child-list"
            itemName="Item"
            items={getItems()}
            tableHead={tableHead}
        />
    );
}

export default DetailList;